<script>
    import { _ } from 'svelte-i18n';
    import { links } from 'svelte-routing';

    export let step;
    export let hidden;
    export let info_active;

    let paragraphs;

    $:{
        if (step == 1) {
            paragraphs = $_('calculator.choose.info_bubble');
        }
        else if (step == 2) {
            paragraphs = $_('calculator.form.info_bubble');
        }
        else if (step == 3) {
            paragraphs = $_('calculator.results.info_bubble');
        }
    }
</script>

<style>

    .info-button {
        position: absolute;
        top: 0;
        right: 30px;
        width: 50px;
        height: 50px;
        background-color: var(--colorElement);
        border-radius: 100%;
        color: var(--colorFgInverse);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
        cursor: pointer;
    }

    .info-box {
        background-color: var(--colorElement);
        padding: var(--spacingMedium);
        border-radius: 4px;
        font-size: var(--typeSizeMedium);
        width: 500px;
        max-width: 80vw;
        position: absolute;
        right: 0;
        top: 55px;
        z-index: 100;
        cursor: initial;
    }

    .info-box span {
        display: block;
    }

    a {
        color: var(--colorFgInverse);
    }

    .questionmark {
        font-size: var(--typeSizeXLarge);
        font-weight: var(--typeWeightRegular);
        margin-left: 2px;
    }

    .hidden {
        display: none;
    }

    @media screen and (max-width: 470px) {
     .info-button {
        right: 0px;
        width: 35px;
        height: 35px;
     }

     .questionmark {
        font-size: var(--typeSizeLarge);
    }
    }

</style>

<div class="info-button" on:click={info_active}>
    <div class:hidden class="info-box" on:click|stopPropagation>
        <!-- The stopPropagation is to make the bubble not close when clicking on the content (only outside of the box) -->
        {#if typeof(paragraphs) != "string"}
            <!-- This is a hack to be able to inject the svelte code on a link in the middle of the text.
            It is a bit ugly, but the on:click and use:links are needed. Feel free to suggest better solutions. -->
            <span>{@html paragraphs[0]}<a on:click={info_active} use:links href="/tabell-utgangsstallningar">{$_('calculator.results.ref_link')}</a>{@html paragraphs[1]}</span>
        {:else}
            <span>{@html paragraphs}</span>
        {/if}
    </div>
    <span class="questionmark">?</span>
</div>
